document.addEventListener('third-party-cookies-accepted', function () {
    const targetELements = document.querySelectorAll('sbk-datawrapper');
    targetELements.forEach((targetElement) => {
        targetElement.thirdParty = true;
    });
});